import { styled as r } from "./styled2.mjs";
import e from "./AccordionSummary.mjs";
import i from "./buttonBaseClasses.mjs";
import o from "./accordionSummaryClasses.mjs";
const p = r(e)`
	padding: ${({ theme: t }) => `0 0 ${t.spacing(1)} 0`};
	margin: 0;
	min-height: unset;
	gap: ${({ theme: t }) => t.spacing(2)};
	color: ${({ theme: t }) => t.palette.text.primary};
	&.${i.root} {
		border-radius: unset;
	}
	&.${o.expanded} {
		min-height: unset;
	}
	> .${o.content} {
		display: flex;
		justify-content: space-between;
		gap: ${({ theme: t }) => t.spacing(2)};
		margin: 0;
	}
`;
export {
  p as AccordionSummary
};
//# sourceMappingURL=styles76.mjs.map
